import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

import { SegmentTabs } from '@/components/SegmentTabs';

export type CommunityViewKey = 'all' | 'saved';

const COMMUNITY_VIEW_TABS = [
  { key: 'all', title: 'All' },
  { key: 'saved', title: 'Saved' },
] as const;

type CommunityViewTabsProps = {
  showSavedPosts: boolean;
  onChange: (view: CommunityViewKey) => void;
};

/**
 * The All | Saved switch above the Inquiry Library list. Short and left-aligned on web, where the
 * page is a centered column. Native keeps the default fill variant.
 */
export function CommunityViewTabs({ showSavedPosts, onChange }: CommunityViewTabsProps) {
  return (
    <SegmentTabs
      tabs={COMMUNITY_VIEW_TABS}
      selectedKey={showSavedPosts ? 'saved' : 'all'}
      onSelect={onChange}
      variant={isWeb ? 'compact' : undefined}
    />
  );
}
